<template>
  <div>
    <iframe
      :src="url"
      frameborder="0"
      id="myiframe"
      width="100%"
      allowtransparency
      v-iframe-resize="{ log: true }"
    ></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      url:
        process.env.VUE_APP_REPORTING_URL + "public/dashboard/e8d7d4bf-11a7-4a16-a3d7-bb94d3b751ec"
    };
  },
  created() {
  },
};
</script>
